import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../config/theme/baseTheme";
import { fontStyles, sharedStyles, detailsHeaderStyles } from "../SharedComponent/styles/sharedStyles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ...sharedStyles(theme),
    root: {
      flexGrow: 1,
    },
    titleContainer: {
      '& .headingContainer': {
        flexDirection: "column",
        '& .titleHeading': {
          ...fontStyles.heading,
          '& .content': {
            fontWeight: 600
          }
        },
        '& .titleContent': {
          ...fontStyles.content,
          '&.link': {
            cursor: "pointer"
          }
        },
        "& .statusContainer": {
          "& .statusIcon": {
            width: 12,
            height: 12,
            borderRadius: "50%",
            '&.yellow': {
              backgroundColor: COLORS.STATUS_YELLOW,
            },
            '&.black': {
              backgroundColor: COLORS.TEXT_PRIMARY,
            },
            '&.green': {
              backgroundColor: COLORS.PERSIAN_GREEN,
            },
            '&.red': {
              backgroundColor: COLORS.DARK_RED,
            },
            '&.gray': {
              backgroundColor: COLORS.GRAY_DARK,
            },
          },
          '& .statusMsg': {
            paddingLeft: theme.spacing(1),
            '& .status': {
              fontSize: 12,
            },
          },
        },
        '& .editIcon': {
          paddingLeft: theme.spacing(1.5),
          '& .icon': {
            cursor: "pointer",
            verticalAlign: "middle",
          },
        },
      },
      '& .tagContainer': {
        cursor: "pointer",
        marginLeft: theme.spacing(2),
        alignSelf: "center",
      },
    },
    contentContainer: {
      flexDirection: "column",
      flexWrap: "nowrap",
      '& .detailsHeader': {
        backgroundColor: COLORS.TRANSPARENT_BLUE,
        padding: theme.spacing(3),
        borderRadius: theme.spacing(1),
        '& .detailsHeaderItem': {
          padding: theme.spacing(2.5, 0, 0, 6),
          '&:first-child': {
            padding: 0,
          },
          '& .profileIcon': {
            width: 140,
            height: 140,
          },
          '& .rightPanelContainer': {
            flexDirection: "column",
            '& .rightPanelItem': {
              paddingBottom: theme.spacing(1.5),
              '&:last-child': {
                paddingBottom: 0,
              },
              '& .fullname': {
                fontSize: 24,
                fontWeight: 600,
              },
              '& .logo': {
                width: 20,
                height: 20,
              },
              '& .contact': {
                '& a': {
                  ...fontStyles.normalText,
                  fontWeight: 600,
                  textDecoration: "none",
                  color: theme.palette.text.primary,
                },
                paddingLeft: theme.spacing(1),
                '&.mobile': {
                  paddingLeft: theme.spacing(1),
                },
              },
            },
          },
        },
      },
      '& .detailsContent': {
        flexDirection: "column",
        flexWrap: "nowrap",
        padding: theme.spacing(3, 0, 2, 0),
        '& .contentRow': {
          paddingBottom: theme.spacing(3),
          '& .contentRowContainer': {
            justifyContent: "space-between",
          },
          '&:last-child': {
            paddingBottom: 0,
          },
          '& .contentColumn': {
            flex: "2 0 0",
            '&.second': {
              flex: "1.5 0 0",
            },
            '&:last-child': {
              flex: "1 0 0",
            },
            '& p': {
              ...fontStyles.normalText,
            },
            '& .label': {
              paddingBottom: theme.spacing(1),
            },
            '& .content': {
              fontWeight: 600,
            },
          },
          '&.twoItems': {
            '& .contentColumn': {
              '&:last-child': {
                flex: "2.5 0 0",
              },
            },
          },
          '&.btnContainer': {
            '& .contentColumn': {
              flex: "1 0 auto",
              '& .resetPasswordBtn': {
                width: "100%",
              },
            },
          },
        },
      },
      '& .hubItemsSection': {
        '& .content': {
          width: "100%",
          '& .itemsContainer': {
            flexWrap: "nowrap",
            '& .item': {
              padding: theme.spacing(2, 0),
              borderBottom: `1px solid ${theme.palette.secondary.dark}`,
              "&:first-child": {
                padding: 0,
                paddingBottom: theme.spacing(2),
              },
              '&:last-child': {
                borderBottom: "none",
              },
              '& .itemContainer': {
                justifyContent: "space-between",
                '& p': {
                  ...fontStyles.normalText,
                  fontWeight: 600,
                },
                '&.header p': {
                  color: COLORS.DOVE_GRAY,
                  fontWeight: 500,
                },
              },
            },
          },
        },
      },
    },
    accordionSummary: {
      '& .header': {
        ...fontStyles.subHeading,
      },
      '& .content': {
        flexGrow: 1,
      },
    },
    buttons: {
      width: "100%",
      '& .userBtn': {
        '&.secondary': {
          marginRight: theme.spacing(2),
        },
        flexGrow: 1,
      },
    },
    dialogPaperPropsRoot: {
      margin: 0,
      marginLeft: "auto",
      maxHeight: "none",
      height: "100vh",
      width: 580,
    },
  }),
);